import React from 'react'
import resources from '../../../services'
import DataTable from '../../../composents/DataTable'
import MainPage from '../../../composents/MainPage'

const title = 'Top Up'
const headers = {
  icon: 'feather icon-credit-card',
  title: title,
  description: 'track and manage all top up information',
}

export default function RechargePage() {
  return (
    <MainPage headers={headers} show_search>
      <DataTable
        column={[
          {
            label: 'Consumer ',
            field: 'consumer',
            render: ['surname'],
          },
          {
            label: 'Subscriptions',
            field: 'subscriptions',
            render: ['title'],
          },
          {
            label: 'HDP quantity',
            field: 'datas',
            render: ['quantity'],
          },
          {
            label: 'Cost',
            field: 'datas',
            render: ['cost'],
          },
          {
            label: 'Payment',
            field: 'datas',
            render: ['type'],
          },
        ]}
        resource={resources.topUp}
        title={title}
        update={false}
        deleteItem={false}
        link="/clients/top_up"
      />
    </MainPage>
  )
}
